import React from 'react';
import clsx from 'clsx';
import { Accordion } from 'react-bootstrap';

import Container from '@common/Container';
import Heading from '@common/Heading';
import Section from '@common/Section';
import Row from '@common/Row';
import RichText from '@common/RichText';
import ContextAwareToggle from '@common/accordion/ContextAwareToggle';

const TextFAQ = ({ data }) => {
  const {
    title,
    showTitle,
    list,
    bgColour
  } = data;
  return (
    <Section className={clsx({[`bg-${bgColour} py-5`]: bgColour })} id='faq'>
      <Container>
        {(showTitle && title) && <Heading type='h2' className='mx-auto mb-4 col-lg-10 text-center'>{title}</Heading>}
        {list &&
          <Row className='mx-auto col-lg-8'>
            <Accordion defaultActiveKey={0} className='d-flex flex-column'>
              {list.map((faq, index) => (
                <div className='mb-2' key={index}>
                  <ContextAwareToggle eventKey={`${index}`} arrow='left'>
                    <Heading type='h3' className={`h4 mb-0`}>{faq.title}</Heading>
                  </ContextAwareToggle>
                  <Accordion.Collapse eventKey={`${index}`}>
                    {faq.text && <RichText json={faq.text}/>}
                  </Accordion.Collapse>
                </div>
              ))}
            </Accordion>
          </Row>
        }
      </Container>
    </Section>
  )
}

export default TextFAQ
